import { ButtonSocial } from '~/components/Buttons'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import GoogleIcon from '~/components/Icons/svgs/GoogleIcon'

import useShowSubscriptionPackagesPageAfterSSO from '~/hooks/useShowSubscriptionPackagesPageAfterSSO'

import useAuthenticateWithGoogle from '../hooks/useAuthenticateWithGoogle'

const ButtonGoogleLogin = ({
  buttonText,
  className = '',
  disabled,
  redirectBack,
}: {
  buttonText?: string
  className?: string
  disabled?: boolean
  redirectBack?: boolean
}): React.ReactElement => {
  const { loading, handleLoginWithGoogle } = useAuthenticateWithGoogle(redirectBack)
  useShowSubscriptionPackagesPageAfterSSO()

  return (
    <ButtonSocial
      className={`flex-1 w-full ${buttonText ? '' : 'rounded-4'} ${className}`}
      disabled={disabled}
      isFullWidth
      isLoading={loading}
      onClick={handleLoginWithGoogle}
      size="small"
      socialType="google"
      spinnerColor="purple"
    >
      <div className="relative w-full flex items-center justify-center">
        <div className={`bg-white h-full rounded ${buttonText ? 'absolute left-0 -mt-1' : 'mx-auto'}`}>
          <SVGIcon icon={GoogleIcon} />
        </div>
        {buttonText && <div className="text-sm font-semibold z-10">{buttonText}</div>}
      </div>
    </ButtonSocial>
  )
}

export default ButtonGoogleLogin
